'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactI18next = require('react-i18next');

var _components = require('components');

var _auth = require('helpers/auth');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoginDialog = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    loginFormState: state.auth.loginFormState,
    user: state.auth.user
  };
}, null, null, { withRef: true }), _dec2 = (0, _reactI18next.translate)(['common'], { withRef: true }), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(LoginDialog, _Component);

  function LoginDialog() {
    (0, _classCallCheck3.default)(this, LoginDialog);
    return (0, _possibleConstructorReturn3.default)(this, (LoginDialog.__proto__ || (0, _getPrototypeOf2.default)(LoginDialog)).apply(this, arguments));
  }

  (0, _createClass3.default)(LoginDialog, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!this.props.user && nextProps.user) {
        this.close();
      }
    }
  }, {
    key: 'getModalTitle',
    value: function getModalTitle() {
      var _titles;

      var _props = this.props,
          t = _props.t,
          loginFormState = _props.loginFormState;

      var titles = (_titles = {}, (0, _defineProperty3.default)(_titles, _auth.loginFormStates.login, t('Login')), (0, _defineProperty3.default)(_titles, _auth.loginFormStates.reset, t('Password expired')), (0, _defineProperty3.default)(_titles, _auth.loginFormStates.unlock, t('Account locked')), _titles);
      return titles[loginFormState] || t('Request new password');
    }
  }, {
    key: 'isModalTitleWarning',
    value: function isModalTitleWarning() {
      var loginFormState = this.props.loginFormState;

      return [_auth.loginFormStates.reset, _auth.loginFormStates.unlock].includes(loginFormState);
    }
  }, {
    key: 'open',
    value: function open() {
      this.modal.open();
    }
  }, {
    key: 'close',
    value: function close() {
      this.modal.close();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var hint = this.props.hint;

      var modalBackdrop = 'static';
      var isCloseByEscEnabled = false;
      var title = this.getModalTitle();

      return _react2.default.createElement(
        _components.Modal,
        {
          ref: function ref(el) {
            return _this2.modal = el;
          },
          title: title,
          warningTitle: this.isModalTitleWarning(),
          backdrop: modalBackdrop,
          closeByEsc: isCloseByEscEnabled,
          dialogClassName: 'modal-login'
        },
        !!hint && _react2.default.createElement(
          'div',
          { className: 'danger' },
          hint
        ),
        _react2.default.createElement(_components.LoginForm, null)
      );
    }
  }]);
  return LoginDialog;
}(_react.Component), _class2.propTypes = {
  hint: _propTypes2.default.string,
  loginFormState: _propTypes2.default.string,
  t: _propTypes2.default.func,
  user: _propTypes2.default.object
}, _temp)) || _class) || _class);
exports.default = LoginDialog;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/LoginDialog/LoginDialog.js
// module id = 863
// module chunks = 1